import I18n from "../../translations/i18n";

const translations = (
  component: string,
  key: string,
  locale: string
): string => {
  return I18n.t(`views.hotel_integration.components.${component}.${key}`, {
    locale: `${locale}`,
  });
};

export default translations;
